import output from "_src/engine/output.js";

export default {

  _chunksVerticesHash: new WeakMap(),

  addDupliVerticesToChunk(chunk, dupliList) {

    if (!dupliList) {
      return;
    }
    chunk.dupliVertices = dupliList;

    for (let vertInd in dupliList) {
      if (chunk.parentVerticesMask[vertInd]) {
        continue;
      }

      const chunkDuplis = dupliList[vertInd];

      for (let i = 0; i < chunkDuplis.length; i += 2) {
        const dupliChunk = chunkDuplis[i];
        const dupliVertInd = chunkDuplis[i + 1];
        dupliChunk.setHasParentVertex(dupliVertInd, 1);
      }
    }

  },

  buildDupliVertices(chunks, chunkToDuplis, searchInChunk = true) {
    for (const chunk of chunks) {
      chunkToDuplis.set(chunk, {});
    }

    const hashMap = new Map();
    for (const chunk of chunks) {
      const positions = chunk.geometry.getLayoutItem("a_position").getBuffer();
      const verticesBorderMaskItem = chunk.geometry.getLayoutItem("vertices_border_mask");

      if (!verticesBorderMaskItem) {
        output.error(output.DEVELOPERS_ERROR, "Can't build dupli vertices: chunk " + chunk.getID() + " doesn't have vertices_border_mask");
        return;
      }

      const verticesBorderMask = verticesBorderMaskItem.getBuffer();

      for (let i=0; i+2<positions.length; i+=3) {
        if (verticesBorderMask[i / 3] !== 1) {
          continue;
        }

        const hash = hashVertex(positions[i], positions[i+1], positions[i+2]);

        const hashEntry = hashMap.get(hash);
        if (!hashEntry) {
          const newHashEntry = [[chunk, i]];
          hashMap.set(hash, newHashEntry);
        } else {

          const newDuplicates = [];
          for (const [anotherChunk, j] of hashEntry) {
            const anotherChunkPositions = anotherChunk.geometry.getLayoutItem("a_position").getBuffer();
            if (anotherChunkPositions[j] === positions[i] && anotherChunkPositions[j+1] === positions[i+1] && anotherChunkPositions[j+2] === positions[i+2]) {
              if (!searchInChunk && anotherChunk === chunk) {
                break;
              }

              newDuplicates.push([[anotherChunk, j], [chunk, i]]);
            }
          }

          hashEntry.push([chunk, i]);
          
          for (const [[anotherChunk, j], [chunk, i]] of newDuplicates) {

            const chunkDuplis = chunkToDuplis.get(chunk);
            if (!chunkDuplis[i/3]) {
              chunkDuplis[i/3] = [];
            }
            chunkDuplis[i/3].push(anotherChunk);
            chunkDuplis[i/3].push(j/3);

            const anotherChunkDuplis = chunkToDuplis.get(anotherChunk);
            if (!anotherChunkDuplis[j/3]) {
              anotherChunkDuplis[j/3] = [];
            }
            anotherChunkDuplis[j/3].push(chunk);
            anotherChunkDuplis[j/3].push(i/3);
          }
        }
      }

    }

  }

}

function hashVertex(x, y, z) {
  return x + y + z;
}
